
import { Component, Vue } from "vue-property-decorator";
import Pagination from "@/components/Pagination/index.vue";
import { IStorageLayerDeliveryNoteInfoModel, IStorageModel } from "@/api/types";
import { getStorages } from "@/api/overivew-diagram";
import {
  storageLayerDeliveryNotes,
  updateStorageColumnRemark,
} from "@/api/storages";
import { Form } from "element-ui";

interface IAreaGroup {
  name: string;
  columns: IStorageLayerDeliveryNoteInfoModel[];
  layerCount: number;
  occupiedCount: number;
  emptyCount: number;
}

@Component({
  name: "WareHouseEntryGuideDiagram",
  components: {
    Pagination,
  },
})
export default class extends Vue {
  private textMap = {
    addStorageColumnRemark: "添加备注",
  };
  private dialogFormVisible = false;
  private dialogStatus = "addStorageColumnRemark";
  private allStorageLayerList: IStorageModel[] = [];
  private cascadeProps = {
    multiple: true,
    emitPath: false,
    value: "id",
    label: "name",
  };
  private iStorageLayerDeliveryNoteModels: IStorageLayerDeliveryNoteInfoModel[] =
    [];
  private listLoading = true;
  private printObj = { id: "printArea", popTitle: "仓位导览图" };
  private listParam = {
    selectedStorageLayer: [],
    storageLayerIds: null,
    deliveryNoteCode: "",
  };
  private tempData = Object.assign({});
  private rules = {
    remark: [{ required: true, message: "备注不能为空" }],
  };
  private collapsedAreas: Record<string, boolean> = {};
  private collapsedColumns: Record<string, boolean> = {};

  get groupedAreas(): IAreaGroup[] {
    const map = new Map<string, IStorageLayerDeliveryNoteInfoModel[]>();
    for (const column of this.iStorageLayerDeliveryNoteModels || []) {
      const areaName = column.storageRowName || "未分组库区";
      if (!map.has(areaName)) {
        map.set(areaName, []);
      }
      map.get(areaName)!.push(column);
    }

    return Array.from(map.entries()).map(([name, columns]) => {
      let layerCount = 0;
      let occupiedCount = 0;
      let emptyCount = 0;
      for (const column of columns) {
        for (const layer of column.items || []) {
          layerCount += 1;
          const occupied =
            (layer.deliveryNoteCodes || []).length +
              (layer.reservedDeliveryNoteCodes || []).length >
            0;
          if (occupied) {
            occupiedCount += 1;
          } else {
            emptyCount += 1;
          }
        }
      }
      return { name, columns, layerCount, occupiedCount, emptyCount };
    });
  }

  created() {
    this.initAllStorageLayerList();
    this.getContent();
  }

  private async initAllStorageLayerList() {
    const data: any = await getStorages();
    this.allStorageLayerList = data;
  }

  private handleFilter() {
    this.getContent();
  }

  private getLayerStatusClass(layer: {
    deliveryNoteCodes: string[];
    reservedDeliveryNoteCodes: string[];
  }) {
    const hasCodes = (layer.deliveryNoteCodes || []).length > 0;
    const hasReserved = (layer.reservedDeliveryNoteCodes || []).length > 0;
    if (hasReserved && hasCodes) return "is-conflict";
    if (hasReserved) return "is-reserved";
    if (hasCodes) return "is-occupied";
    return "is-empty";
  }

  private getLayerStatusLabel(layer: {
    deliveryNoteCodes: string[];
    reservedDeliveryNoteCodes: string[];
  }) {
    const hasCodes = (layer.deliveryNoteCodes || []).length > 0;
    const hasReserved = (layer.reservedDeliveryNoteCodes || []).length > 0;
    if (hasReserved && hasCodes) return "混占";
    if (hasReserved) return "预留";
    if (hasCodes) return "占用";
    return "空闲";
  }

  private isAreaCollapsed(name: string) {
    return !!this.collapsedAreas[name];
  }

  private isColumnCollapsed(id: string) {
    return !!this.collapsedColumns[id];
  }

  private toggleArea(name: string) {
    this.$set(this.collapsedAreas, name, !this.collapsedAreas[name]);
  }

  private toggleColumn(id: string) {
    this.$set(this.collapsedColumns, id, !this.collapsedColumns[id]);
  }

  private expandAll() {
    this.collapsedAreas = {};
    this.collapsedColumns = {};
  }

  private collapseAll() {
    const areas: Record<string, boolean> = {};
    const columns: Record<string, boolean> = {};
    for (const area of this.groupedAreas) {
      areas[area.name] = true;
      for (const column of area.columns) {
        columns[column.storageColumnId] = true;
      }
    }
    this.collapsedAreas = areas;
    this.collapsedColumns = columns;
  }

  private async getContent() {
    this.listLoading = true;
    const params = Object.assign({}, this.listParam);
    if (params.selectedStorageLayer) {
      params.storageLayerIds = params.selectedStorageLayer.join(",");
      params.selectedStorageLayer = null;
    }
    const result: any = await storageLayerDeliveryNotes(params);
    this.iStorageLayerDeliveryNoteModels = result.content;
    this.expandAll();

    setTimeout(() => {
      this.listLoading = false;
    }, 0.3 * 1000);
  }

  private showForm(storageColumnId: string, remark: string) {
    this.tempData = { id: storageColumnId, remark: remark };
    this.dialogFormVisible = true;
  }

  private closeForm() {
    this.tempData = {};
    this.dialogFormVisible = false;
  }

  private updateStorageColumnRemark() {
    (this.$refs.dataForm as Form).validate(async (valid) => {
      if (valid) {
        await updateStorageColumnRemark(this.tempData.id, {
          remark: this.tempData.remark,
        });
        this.$notify({
          title: "成功",
          message: "更新成功",
          type: "success",
          duration: 2000,
        });
        this.dialogFormVisible = false;
        this.tempData = {};
        await this.getContent();
      }
    });
  }
}
